// extracted by mini-css-extract-plugin
export default {"root":"AgjoPam38ZTuVWDc2Q8A"};